export default __webpack_public_path__ + "static/media/27dffa44407fc1556617f99eaa18ed92.svg";